import React from "react";
import { Container, Typography, Divider, Box, Button, Stack } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useTranslation } from 'react-i18next';

export default function ReportIssue() {
    const { t } = useTranslation();
    const email = "adm.szno@gmail.com";
    const subject = "Hibajelentés – Székely Nemzet Online";

    return (
        <Container maxWidth="md" sx={{ mt: '50px', py: 4 }}>
            <Typography variant="h3" gutterBottom>
                Probléma jelentése
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography paragraph>
                Ezen az oldalon jelezheti, ha technikai hibát,
                hiányosságot vagy működési rendellenességet tapasztalt
                a Székely Nemzet Online felületén.
            </Typography>

            <Typography paragraph>
                Kérjük, az üzenetben a lehető legpontosabban írja le a problémát,
                valamint azt is, hogy melyik oldalon vagy funkciónál jelentkezett.
            </Typography>

            <Box sx={{ mt: 4, textAlign: "center" }}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center" alignItems="center">
                    <Button
                        variant="contained"
                        startIcon={<EmailIcon />}
                        href={`mailto:${email}?subject=${encodeURIComponent(subject)}`}
                        sx={{ minWidth: '200px' }}
                    >
                        E-mail küldése
                    </Button>

                    <Button
                        variant="contained"
                        startIcon={<WhatsAppIcon />}
                        href="https://wa.me/40742068177"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            backgroundColor: '#25D366',
                            '&:hover': {
                                backgroundColor: '#128C7E',
                            },
                            minWidth: '200px'
                        }}
                    >
                        {t('Footer.WhatsAppSupport')}
                    </Button>
                </Stack>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 2 }}
                >
                    Az üzenet az alapértelmezett levelezőprogramjában vagy a WhatsApp alkalmazásban fog megnyílni.
                </Typography>
            </Box>
        </Container>
    );
}
